import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import RouteKey from './key';
import TransactionPage from '../pages/transaction/CoordinatorTransactionListing/TransactionPage';
import ViewDetailsPage from '../pages/transaction/CoordinatorTransactionListing/ViewDetailsPage';
import PrivateRoute from '../modules/profile/components/PrivateRoute';
import { Role } from '../models';

const { error: errorRoute } = RouteKey.child;
const { candidate, coordinator, viewDetails } = RouteKey.transaction.child;
const TransactionRoute = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PrivateRoute exact path={`${path}/${candidate.route}`} roles={[Role.candidate]}>
        <TransactionPage />
      </PrivateRoute>

      <PrivateRoute exact path={`${path}/${coordinator.route}`} roles={[Role.coordinator]}>
        <TransactionPage isCoordinator />
      </PrivateRoute>

      <PrivateRoute
        path={`${path}/${coordinator.route}/:candidateUuid/${viewDetails.route}`}
        roles={[Role.coordinator]}
      >
        <ViewDetailsPage />
      </PrivateRoute>

      <Route path="*" exact>
        <Redirect to={`/${errorRoute}`} />
      </Route>
    </Switch>
  );
};
export default TransactionRoute;
